export const InitialData = {
  vehicle_details: {
    vehicle_reg_no: "",
    access_code: "",
    customer_id_type: "",
    owner_id: "",
    make_model: "",
    opc_vehicle_id: "",
    is_opc_car: 0,
  },
  vehicle_documents: {
    log_card: [],
    sale_agreement: [],
    additional_documents: [],
  },
  disbursement_documents: {
    transaction_history: [],
    vehicle_information: [],
    vehicle_acknowledgement: [],
    insurance_certificate: [],
    number_retention_letter: [],
  },
  vehicle_details_new: {
    vehicle_reg_no: "",
    customer_id_type: "",
    owner_id: "",
    make_model: "",
    opc_vehicle_id: "",
    is_opc_car: "",
    vehicle_under_opc: "",
    vehicle_emission_scheme: "",
    vehicle_coe_category: "",
    vehicle_coe_amount: "",
    vehicle_ori_reg_date: "",
    vehicle_chassis_no: "",
    vehicle_engine_no: "",
    vehicle_omv: "",
    vehicle_purchase_price: "",
    vehicle_yom: "",
  },
  vehicle_documents_new: {
    sale_agreement: [],
    additional_documents: [],
    vehicle_overseas_log_card: [],
    data_card: [],
    cargo_clearance_permits: [],
    bill_of_lading: [],
    letter_of_newness: [],
  },
  applicant_details: {
    title: "",
    name: "",
    nric: "",
    dob: "",
    gender: "",
    race: "",
    name_of_spouse: "",
    home_no: "",
    mobile_no: "",
    office: "",
    email: "",
    marital_status: "",
    residence_type: "",
    home_address: "",
    postal_code: "",
    home_address_same_as_mailing: "",
    mailing_residence_type: "",
    mailing_home_address: "",
    mailing_postal_code: "",
  },
  applicant_details_work_pass: {
    title: "",
    name: "",
    dob: "",
    gender: "",
    race: "",
    name_of_spouse: "",
    home_no: "",
    mobile_no: "",
    office: "",
    email: "",
    marital_status: "",
    residence_type: "",
    home_address: "",
    postal_code: "",
    home_address_same_as_mailing: "",
    mailing_residence_type: "",
    mailing_home_address: "",
    mailing_postal_code: "",
    passport_expiry_date: "",
    fin_no: "",
    nationality: "",
  },
  applicant_details_foreign: {
    title: "",
    name: "",
    dob: "",
    gender: "",
    race: "",
    name_of_spouse: "",
    home_no: "",
    mobile_no: "",
    office: "",
    email: "",
    marital_status: "",
    residence_type: "",
    home_address: "",
    postal_code: "",
    home_address_same_as_mailing: "",
    mailing_residence_type: "",
    mailing_home_address: "",
    mailing_postal_code: "",
    passport_expiry_date: "",
    passport_no: "",
    nationality: "",
  },
  applicant_details_company: {
    company_name: "",
    uen_acra_no: "",
    name: "",
    date_of_incorporation: "",
    mobile_no: "",
    office: "",
    email: "",
    company_address: "",
    company_postal_code: "",
    mailing_company_address: "",
    mailing_company_postal_code: "",
    company_address_same_as_mailing: "",
  },
  applicant_employement_details: {
    employment_type: "",
    occupation: "",
    type_of_industry: "",
    service_duration_years: "",
    service_duration_months: "",
    monthly_income: "",
    other_income: "",
    finance_type: "",
    employer_name: "",
    employer_address: "",
    employer_postal_code: "",
    employer_previous_occupation: "",
    employer_previous_name: "",
    employer_previous_experience_years: "",
    employer_previous_experience_months: "",
    employer_previous_address: "",
    employer_previous_postal_code: "",
  },
  applicant_declaration: {
    declaration_date: "",
    received_discount_benefits: "",
    benefit_vendor_name: null,
    benefit_value: null,
    credit_hire_purchase: "",
    credit_facility_name: null,
    credit_value: null,
    sing_investment_related: "",
    sing_relationship_type: null,
    releated_with_vendor: "",
    vendor_relationship_type: null,
    credit_facility_with_sing_investment: "",
    sing_investment_credit_value: null,
    legal_actions: "",
    account_closed_by_singapore: "",
    closed_accounts_count: null,
    past_account_ssl: "",
    giro_account_no: null,
    past_account_tokyo_century: "",
    tokyo_century_account_no: null,
    primary_driver: "",
    driver_relationship: null,
    driver_name: null,
    driver_nric: null,
    legal_action_content: null,
    form_data: [],
  },
  guarantor_details: {
    personal_details: {
      title: "",
      name: "",
      nric: "",
      dob: "",
      gender: "",
      race: "",
      name_of_spouse: "",
      home_no: "",
      mobile_no: "",
      office: "",
      email: "",
      marital_status: "",
      residence_type: "",
      home_address: "",
      postal_code: "",
      home_address_same_as_mailing: "",
      mailing_residence_type: "",
      mailing_home_address: "",
      mailing_postal_code: "",
      company_address: "",
      company_postal_code: "",
      passport_expiry_date: "",
      date_of_incorporation: "",
      fin_no: "",
      passport_no: "",
      nationality: "",
    },
    employemnt_details: {
      employment_type: "",
      occupation: "",
      type_of_industry: "",
      service_duration_years: "",
      service_duration_months: "",
      monthly_income: "",
      other_income: "",
      finance_type: "",
      employer_name: "",
      employer_address: "",
      employer_postal_code: "",
      employer_previous_occupation: "",
      employer_previous_name: "",
      employer_previous_experience_years: "",
      employer_previous_experience_months: "",
      employer_previous_address: "",
      employer_previous_postal_code: "",
    },
    documents: {
      nric: [],
      nao: [],
      cpf: [],
      driving_license: [],
      additional_documents: [],
      bank_statement: [],
    },
  },
  guarantor_data: {
    guarantor_type: "",
    guarantor_citizenship_type: "",
  },
  documents: {
    nric: [],
    nao: [],
    cpf: [],
    driving_license: [],
    additional_documents: [],
    bank_statement: [],
    guarantor_data_index: 1,
  },
  stepStatus: {
    step1: {
      completed: false,
      viewed: false,
    },
    step2: {
      completed: false,
      viewed: false,
    },
    step3: {
      completed: false,
      viewed: false,
    },
    step4: {
      completed: false,
      viewed: false,
    },
    step5: {
      completed: false,
      viewed: false,
    },
    step6: {
      completed: false,
      viewed: false,
    },
    step7: {
      completed: false,
      viewed: false,
    },
    step8: {
      completed: false,
      viewed: false,
    },
  },
};
